"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUngated = exports.getGates = void 0;

var getGates = function getGates(state) {
  return state.gates;
};

exports.getGates = getGates;

var isUngated = function isUngated(state, gate) {
  return Boolean(getGates(state)[gate]);
};

exports.isUngated = isUngated;